module.exports = __webpack_public_path__ + "static/media/four-tokens.da8b9d75.svg";